import { Text } from '@kerfjs/ui/text';
import type { SafeHtml } from 'kerfjs';

import { primaryView } from '../../../components/ui-helpers.js';
import { isRequester } from '../../../lib/context.js';
import { ChatSidebar } from './chat-sidebar.js';
import { DemandsSidebar } from './demands-sidebar.js';
import { SettingsSidebar } from './settings-sidebar.js';
import { StatsSidebar } from './stats-sidebar.js';

/** Contextual navigation content for the current application view. */
export function SidebarList({ view: v }: { view: string }): SafeHtml {
  if (isRequester()) return v === 'settings' ? <SettingsSidebar view={v} /> : <DemandsSidebar />;
  const primary = primaryView(v);
  if (primary === 'demands') return <DemandsSidebar />;
  if (primary === 'chat') return <ChatSidebar />;
  if (primary === 'stats') return <StatsSidebar />;
  if (v === 'settings' || v === 'vendors' || v === 'library') return <SettingsSidebar view={v} />;
  return (
    <Text tone="quiet" size="compact">
      No list for this view.
    </Text>
  );
}
